import {
  Box,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import { useState } from "react";

function Shipping() {
  const [value, setValue] = useState("female");

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <Box>
      <Box sx={{ marginBottom: "20px" }}>
        <Typography>Import Tax & Duty</Typography>
      </Box>
      <Box>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={value}
            onChange={handleChange}
          >
            <FormControlLabel
              value="pre-paid-duties"
              control={<Radio size="small" />}
              label="Pre-Paid Duties"
            />
            <FormControlLabel
              value="post-paid-duties"
              control={<Radio size="small" />}
              label="Post-Paid Duties"
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box
        sx={{
          backgroundColor: "#F7F7F7",
          display: "flex",
          alignItems: "center",
          padding: "10px",
          border: "1px solid #E5E5E8",
          borderRadius: "1px",
          marginTop: "20px"
        }}
      >
        <Checkbox size="small" />
        <Typography
          sx={{ fontSize: "14px", color: "#1C2630", fontWeight: 500 }}
        >
          Shipping Insurance
        </Typography>
      </Box>
    </Box>
  );
}

export default Shipping;
